export const GIFT_PARAM = 'gift'
export const PRODUCT_ID_PARAM = 'product_id'
